const hamburger = document.querySelector('.hamburger')
const mobMenu = document.querySelector('.mob-menu')
const mobCloseBtn = mobMenu.querySelector('.close-btn')

hamburger.onclick = () => {
  mobMenu.classList.add('active')
}

mobCloseBtn.onclick = () => {
  mobMenu.classList.remove('active')
}


